// initial state
// shape: [{ category, description, price }]
function initialState() {
	return {
		items: []
	}
}
const state = initialState()

// getters
const getters = {
	cartCharges: (state) => {
		return state.items;
	},
	cartTotalCharge: (state, getters) => {
		return getters.cartCharges.reduce((total, charge) => {
			return total + charge.Price
		}, 0)
	},
}

// actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addChargeToCart ({ state, commit }, charge) {
		return new Promise((resolve, reject) => {
			commit('pushChargeToCart', { Category: charge.Category, Description: charge.Description, Price: charge.Price })
			resolve()
		})
	},
	removeChargeFromCart ({ state, commit }, chargeID) {
		commit('pullChargeFromCart', chargeID)
	},
}

// mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	pushChargeToCart (state, { Category, Description, Price }) {
		state.items.push({
			Category,
			Description,
			Price
		})
	},
	pullChargeFromCart (state, id) {
		state.items.splice(id, 1)
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
